import { render, staticRenderFns } from "./HospitalIcon.vue?vue&type=template&id=6b845402&scoped=true&"
import script from "./HospitalIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./HospitalIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b845402",
  null
  
)

export default component.exports